import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from '../../services/PermissionService';
import { UserService } from '../../services/UserService';
import { User } from '@socrates/common';

@Directive ({
	selector: '[ngPrivilege]',
	standalone: false,
})
export class PrivilegeDirective {
	private _loggedInUser: User;
	private _authorized: boolean;
	private _privilege: string;

	constructor(
		private userService: UserService,
		private permissionService: PermissionService,
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef
	) {
	}

	@Input() set ngPrivilege(privilege: string) {
		this._privilege = privilege;
		if (!this._privilege) return;

		this._loggedInUser = this._loggedInUser ?? this.userService.getUser();
		if (this._loggedInUser) {
			this.privilegeCheck();
		} else {
			this.userService.checkSession().then((user: User) => {
				this._loggedInUser = user;
				this.privilegeCheck();
			}).catch(() => {});
		}
	}

	private privilegeCheck(): void {
		if (this._loggedInUser && this.permissionService.permitted(this._loggedInUser, this._privilege)) {
			if (!this._authorized) {
				this.viewContainerRef.createEmbeddedView(this.templateRef);
				this._authorized = true;
			}
		} else if (this._authorized) {
			this.viewContainerRef.clear();
			this._authorized = false;
		}
	}
}
